const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargeSessions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M480.6 152.3h-19.4V48.2c0-11.3-9.1-20.4-20.4-20.4-11.3 0-20.4 9.1-20.4 20.4v104.1h-82.8V48.2c0-11.3-9.1-20.4-20.4-20.4-11.3 0-20.4 9.1-20.4 20.4v104.1h-19.4c-11.3 0-20.4 9.1-20.4 20.4v93.9c0 60.1 43.8 110.2 101.2 120-3.8 41.2-38.6 73.6-80.8 73.6-44.8 0-81.2-36.4-81.2-81.2V101.7c0-50-41.5-90.7-92.6-90.7C52.5 11 11 51.7 11 101.7v276.9c0 11.3 9.1 20.4 20.4 20.4 11.3 0 20.4-9.1 20.4-20.4V101.7c0-27.5 23.2-49.8 51.7-49.8 28.5 0 51.8 22.4 51.8 49.8V379c0 67.3 54.7 122 122 122 64.7 0 117.8-50.6 121.8-114.3C456.9 377.2 501 327 501 266.6v-93.9c0-11.2-9.1-20.4-20.4-20.4Zm-20.4 114.3c0 44.6-36.3 80.9-80.9 80.9h-.7c-44.6 0-80.9-36.3-80.9-80.9v-73.5h162.4v73.5h.1Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(.04286 0 0 .04286 .029 .029)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeSessions);
export default __webpack_public_path__ + "static/media/charge-sessions.dc3359c42f505886342757e1e63a857e.svg";
export { ForwardRef as ReactComponent };